/**
 * Feature Flag Lambda ARN configuration per environment
 * Cross-account Lambda functions for AppConfig feature flags
 */

export enum DeploymentStage {
  DEV = 'dev',
  BETA = 'beta',
  GAMMA = 'gamma',
  PROD = 'prod',
}

export const FINSPACE_FEATURE_FLAG_HANDLER_CONFIG: Record<
  string,
  { accountId: string; functionName: string }
> = {
  [DeploymentStage.DEV]: {
    accountId: '717475032627',
    functionName: 'FinSpace-FeatureFlagHandler',
  },
  [DeploymentStage.BETA]: {
    accountId: '723013807888',
    functionName: 'FinSpace-FeatureFlagHandler',
  },
  [DeploymentStage.GAMMA]: {
    accountId: '739157244415',
    functionName: 'FinSpace-FeatureFlagHandler',
  },
  [DeploymentStage.PROD]: {
    accountId: '545365949630',
    functionName: 'FinSpace-FeatureFlagHandler',
  },
};

/**
 * Get the Lambda ARN for the current stage and region
 * Falls back to BETA if stage is not found
 */
export const getFeatureFlagLambdaArn = (
  stage: string,
  region: string,
): string => {
  const config = FINSPACE_FEATURE_FLAG_HANDLER_CONFIG[stage.toLowerCase()];
  if (!config) {
    console.warn(
      `[FeatureFlags] Unknown stage "${stage}", falling back to BETA`,
    );
    const betaConfig = FINSPACE_FEATURE_FLAG_HANDLER_CONFIG[DeploymentStage.BETA];
    return `arn:aws:lambda:${region}:${betaConfig.accountId}:function:${betaConfig.functionName}:live`;
  }
  return `arn:aws:lambda:${region}:${config.accountId}:function:${config.functionName}:live`;
};
